import React, { useEffect, useState } from "react";
import InputComponent from "../../components/Input";
import ButtonComponent from "../../components/Button";
import SelectDropdown from "../../components/SelectDropdown";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { collectCashAction } from "../../store/actions/admin-actions";
import { GetMemberByRole } from "../../store/actions/user-action";

const CollectCash = () => {
    const dispatch = useDispatch();
      const { memberDetails } = useSelector((state) => state.memberDetails);
      const [driverList, setDriverList] = useState([])


    useEffect(() => {
        const driverList = memberDetails.map((driver) => ({ label: driver?.name, value: driver?._id }));
        setDriverList(driverList)
    }, [memberDetails])
      
    const validationSchema = Yup.object({
        driverId: Yup.string().required("Driver ID is required"),
        type: Yup.string()
            .oneOf(["credit", "debit"])
            .required("Type is required"),
        amount: Yup.number().required('Amount is required')
            .required("Amount is required"),
    });

    // Calling the driver list
    useEffect(() => {
        dispatch(GetMemberByRole('driver'));
    }, [])


    const formik = useFormik({
        initialValues: {
            driverId: "",
            type: "percentage",
            amount: false
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            dispatch(collectCashAction(values));
        },
    });

    return (
        <div className="p-[25px] rounded-md border bg-white">
            <h3 className="font-medium">Collect Cash from Rider</h3>
            <form className="mt-5" onSubmit={formik.handleSubmit}>
                <div className="flex space-x-8">
                    {/* Left Column */}
                    <div className="w-1/2">

                        <label className="block text-sm font-medium text-gray-900">
                            Enter Driver Id
                        </label>
                        <SelectDropdown
                            name="driverId"
                            options={driverList}
                            placeholder="Choose Type"
                            value={formik.values.driverId}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.driverId && formik.errors.driverId}
                            isDisabled
                        />
                        {formik.touched.driverId && formik.errors.driverId && (
                            <div className="text-red-500 text-sm">
                                {formik.errors.driverId}
                            </div>
                        )}

                        <label className="block text-sm font-medium text-gray-900 mt-4">
                            Amount
                        </label>
                        <InputComponent
                            icon={''}
                            type="number"
                            error={''}
                            name="amount"
                            placeholder="Enter Amount"
                            value={formik.values.amount}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {formik.touched.amount && formik.errors.amount && (
                            <div className="text-red-500 text-sm">
                                {formik.errors.amount}
                            </div>
                        )}

                    </div>

                    <div className="w-1/2">
                        <label className="block text-sm font-medium text-gray-900">
                            Entry Type
                        </label>
                        <SelectDropdown
                            name="type"
                            options={[
                                { value: "credit", label: "Credit" },
                                { value: "debit", label: "Debit" },
                            ]}
                            placeholder="Choose Type"
                            value={formik.values.type || 'debit'}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.type && formik.errors.type}
                            isDisabled
                        />

                        {/* Submit Button */}
                        <div className="mt-8 text-right">
                            <ButtonComponent
                                text="Update Driver Passbook"
                                disabled={!formik.isValid || formik.isSubmitting}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default React.memo(CollectCash);
